import React, { useEffect, useState } from 'react';
import ModalForm from '../Reusable/ModalForm';
import { SubmitButton } from '../../enums/GlobalEnums';
import { ModalForAddOrUpdateTravelOrder } from '../../enums/TravelOrderEnums';
import { findTravelOrderById } from '../../actions/travelOrder';
import { useDispatch } from 'react-redux';
import dayjs from 'dayjs';

const ModalForUpdateTravelOrder = ({
  travelOrder,
  updateTravelOrder,
  handleClose,
  show,
  travelOrderReducer,
  municipalities,
}) => {
  const { error } = travelOrderReducer;
  const dispatch = useDispatch();


  useEffect(() => {
    dispatch(findTravelOrderById());
  }, [dispatch]);


  const fields = [
    {
      name: 'startDateTime',
      label: 'Datum i vreme polaska',
      type: 'datetime',
    },
    {
      name: 'returnDateTime',
      label: 'Datum i vreme povratka',
      type: 'datetime',
    },
    {
      name: 'startPointId',
      label: 'Mesto polaska',
      type: 'select',
      options: (municipalities || []).map((m) => ({
        value: m.id,
        label: m.name,
      })),
    },
    {
      name: 'returnPointId',
      label: 'Mesto dolaska',
      type: 'select',
      options: (municipalities || []).map((m) => ({
        value: m.id,
        label: m.name,
      })),
    },
    {
      name: 'refueling',
      label: 'Natočeno goriva',
      type: 'number',
    },
    {
      name: 'startingMileage',
      label: 'Početna kilometraža',
      type: 'number',
    },
    {
      name: 'finalMileage',
      label: 'Krajnja kilometraža',
      type: 'number',
    },
  ];

  const [initialValues, setInitialValues] = useState({
    startDateTime: '',
    returnDateTime: '',
    startPointId: '',
    returnPointId: '',
    refueling: '',
    startingMileage: '',
    finalMileage: '',
  });


  useEffect(() => {
    if (show && travelOrder) {
      console.log("TRAVEL ORDER:", travelOrder);

      setInitialValues({
        startDateTime: travelOrder.startDateTime
          ? dayjs(travelOrder.startDateTime, 'DD.MM.YYYY HH:mm')
          : null,

        returnDateTime: travelOrder.returnDateTime
          ? dayjs(travelOrder.returnDateTime, 'DD.MM.YYYY HH:mm')
          : null,
        startPointId: travelOrder.startPointId || '',
        returnPointId: travelOrder.returnPointId || '',
        refueling: travelOrder.refueling || '',
        startingMileage: travelOrder.startingMileage || '',
        finalMileage: travelOrder.finalMileage || '',
      });
    }
  }, [travelOrder, show]);

  const handleSubmit = (formData) => {
    const updatedTravelOrder = {
      ...travelOrder,
    ...formData,
    startDateTime: dayjs(formData.startDateTime).format('DD.MM.YYYY HH:mm'),
    returnDateTime: dayjs(formData.returnDateTime).format('DD.MM.YYYY HH:mm'),
        };

    console.log("UPDATE", updatedTravelOrder);
    updateTravelOrder(updatedTravelOrder);
  };

  return (
    <ModalForm
      open={show}
      onClose={handleClose}
      title={ModalForAddOrUpdateTravelOrder.titleForUpdateTravelOrder}
      fields={fields}
      onSubmit={handleSubmit}
      initialValues={initialValues}
      error={error}
      submitLabel={SubmitButton.update}
    />
  );
};

export default ModalForUpdateTravelOrder;
